<template>
    <span class="question-id">
        Q{{ id }}
    </span>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
    /**
     * Displays a question ID for debugging/reference purposes
     * */
    import Vue from 'vue'

    export default Vue.extend({
        name: 'QuestionId',
        props: { id: Number },
    })
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">
    .question-id {
        color: #bbb;
    }
</style>
